import { toArray } from '../transform/index';

export async function readFile(file) {
  const reader = new FileReader();
  return new Promise(resolve => {
    reader.addEventListener('load', event => {
      resolve(event.target.result);
    });

    reader.readAsDataURL(file);
  });
}

export function base64ImgToUrl(base64String) {
  const binaryString = atob(base64String.split(',')[1]);
  const uint8Array = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }

  const blob = new Blob([uint8Array], { type: 'image/png' });
  return URL.createObjectURL(blob);
}

/**
 * 图片File转URL
 * @param {*} file
 * @returns {string}
 */
export async function imgFileToUrl(file) {
  const base64Str = await readFile(file);
  return base64ImgToUrl(base64Str);
}

/**
 * 撤销ObjectUrl
 * @param {string|string[]} urls
 */
export function revokeUrl(urls) {
  const temp = toArray(urls);
  temp.forEach(URL.revokeObjectURL);
}

/**
 * @example downloadBlobAsFile(res.blob, res.fileName, () => {
 *   console.log('File downloaded successfully!');
 * });
 * @param {*} blob
 * @param {*} fileName
 * @param {*} callback
 */
export function downloadBlobAsFile(blob, fileName, callback) {
  const a = document.createElement('a');

  if (navigator.msSaveBlob == null) {
    if (fileName) {
      a.download = fileName;
    } else {
      // 如果没有提供文件名，则默认使用blob中的文件名
      a.download = 'download';
    }
    a.href = URL.createObjectURL(blob);

    // 在firefox中修复无法触发click的问题
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(a.href);
    document.body.removeChild(a);
  } else {
    // 兼容IE浏览器
    navigator.msSaveBlob(blob, fileName);
  }

  // 如果提供了回调函数，调用它
  if (typeof callback === 'function') {
    callback();
  }
}

/**
 * 下载指定URL对应的文件
 *
 * @param {string} url 文件URL
 */
export function downloadFileByUrl(url) {
  const a = document.createElement('a');
  a.download = 'download';
  a.href = url;
  a.target = '_blank';

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function getBlobByUrl(url) {
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest();

    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response);
      }
    };

    xhr.send();
  });
}
